import React, {useCallback, useEffect, useRef, useState} from "react";
import Navbar from "../elements/Navbar";
import {isExists} from "../utils";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {EVENT_TYPE, MONGO_STATUS, SELECTED_GAME, USER_ROLE} from "../constants";

import {CSSHelper} from "@bryntum/scheduler/scheduler.umd";
import {Box} from "@mui/material";
import HelpButton from "../components/HelpButton";
import {getMephistoEvents, pushBulkEventsToAsana, sendAddEvent, sendUpdateEvent} from "../requests";
import {DISCONNECT_WEBSOCKET} from "../redux/websocket/websocketReducer";
import {getCommonConfigs} from "./bryntum_configs/commonConfigs";
import {getViewerConfigs} from "./bryntum_configs/viewerConfigs";
import {setStylesForNewEvents} from "./bryntum_helpers";
import {getConfigByGame} from "../redux/userReducer";
import {fetchMephistoConfig} from "../redux/mephisto/actions";

const manageCalendar = (Calendar, game) => {

    return () => {
        const navigate = useNavigate()
        const user = useSelector((state) => state.user.currentUser);
        const [searchParams, setSearchParams] = useSearchParams();

        const colorConfig = useSelector((state) => state.calendarConfig.taskColorConfig)
        //const mephistoConfig = useSelector((state) => state.mephistoConfig);

        const schedulerRef = useRef();

        const [mephistoCompare, setMephistoCompare] = useState(false);
        const [cnMode, setCnMode] = useState(false);
        const [eventStore, setEventStore] = useState(null);
        const [dependencyStore, setDependencyStore] = useState(null);
        const [eventRecord, setEventRecord] = useState(null);
        const [resourceRecord, setResourceRecord] = useState(null);
        const [resourceStore, setResourceStore] = useState(null);
        const [popupShown, showPopup] = useState(undefined);
        const [mephistoLoading, setMephistoLoading] = useState(false);
        const dispatch = useDispatch()
        const [selectedItems, setSelectedItems] = useState([])

        useEffect(() => {
                function initStore() {
                    const {eventStore, resourceStore, dependencyStore} = schedulerRef.current.schedulerInstance;
                    setEventStore(eventStore);
                    setResourceStore(resourceStore);
                    setDependencyStore(dependencyStore)
                }

                if (user.email !== undefined && isExists(schedulerRef.current)) {
                    let yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 7);
                    schedulerRef.current.schedulerInstance.scrollToDate(yesterday, {block: "start"});
                    CSSHelper.insertRule(`.b-sch-label-none { display: none!important}`);
                    initStore();
                }
            }, [user.email]
        );
        useEffect(() => {
            const listener = (e) => {
                if (e.key === "Escape") {
                    hideEditor()
                }
            }

            document.addEventListener("keydown", listener, false)

            return () => {
                document.removeEventListener("keydown", listener, false)
                dispatch({type: DISCONNECT_WEBSOCKET})
                handleSelectGame(SELECTED_GAME.NO_GAME)
            }
        }, [])


        const showNoteEditor = useCallback((eventRecord) => {
            //пример _generatedClassDefEx1
            // eventRecord.type = resourceRecord.data.type;
            setEventRecord(eventRecord);
            showPopup("noteEdit");
        }, []);

        function isEqualMephistoDates(eventDate, mephistoDate) {
            function roundToHour(date) {
                const newDate = new Date(date);
                newDate.setMinutes(0, 0, 0);
                return newDate;
            }

            const calendarDate = new Date(eventDate);

            const tsDate = new Date(mephistoDate * 1000);

            const localTimezoneOffset = new Date().getTimezoneOffset();

            const mephistoTimezoneOffset = -180;

            const timezoneCorrection = (mephistoTimezoneOffset - localTimezoneOffset) / 60;
            calendarDate.setHours(calendarDate.getHours() + timezoneCorrection);

            const roundedEventDate = roundToHour(calendarDate);
            const roundedMephistoDate = roundToHour(tsDate);

            const diffHours = Math.abs(roundedEventDate - roundedMephistoDate) / (1000 * 60 * 60);

            return diffHours === 0;
        }


        function handleCnMode(mode) {
            debugger
            const scheduler = schedulerRef.current.schedulerInstance;

            if(mode === 'CN') {
                eventStore.beginBatch();

                eventStore.records.forEach(item => {
                    if(item.cn === false) {
                        item.style = 'display: none;opacity: 0;'
                    } else {
                        item.style = ''
                    }
                });

                eventStore.endBatch();

                resourceStore.clearFilters();
                resourceStore.filter(resource => {
                    return resource.name.includes("China") || !resource.name.includes("Сабмит/Релиз");
                });

            } else if(mode === 'WW') {
                eventStore.beginBatch();

                eventStore.records.forEach(item => {
                    if(item.ww === false) {
                        item.style = 'display: none;opacity: 0;'
                    } else {
                        item.style = ''
                    }
                });

                eventStore.endBatch();


                resourceStore.clearFilters();
                resourceStore.filter(resource => {
                    return !resource.name.includes("China");
                });
            } else {
                eventStore.beginBatch();

                eventStore.records.forEach(item => {
                    item.style = ''
                });

                eventStore.endBatch();


                resourceStore.clearFilters();

            }
            setCnMode(mode)
        }

        function handleMephistoMode() {
            setMephistoLoading(true)

            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

            if(!mephistoCompare) {
                eventStore.beginBatch();

                const recentEvents = eventStore.records.filter(item =>
                    new Date(item.startDate) >= oneMonthAgo && item.type == "event"
                );

                recentEvents.forEach(item => {
                    item.eventColorSource = item.eventColor;
                    item.eventColor = '#f00';
                });

                getMephistoEvents().then(data => {
                    const eventMap = new Map();
                    recentEvents.forEach(event => {
                        eventMap.set(event.eventId, event);
                    });

                    data.campaigns.forEach(item => {
                        const record = eventMap.get(item.id);

                        if (record) {
                            if (isEqualMephistoDates(record.startDate, item.distribution.from) &&
                                isEqualMephistoDates(record.endDate, item.distribution.till)) {
                                record.eventColor = '#0f0';
                            } else {
                                record.eventColor = '#ffd400';
                            }
                        }
                    });
                    eventStore.endBatch();
                    setMephistoLoading(false)

                }).catch((e) => {
                    console.error('Error loading Mephisto events:', e);
                    eventStore.endBatch();
                    setMephistoLoading(false)

                })

            } else {
                eventStore.beginBatch();
                eventStore.records
                    .filter(item => new Date(item.startDate) >= oneMonthAgo && item.type == "event")
                    .forEach(item => {
                        item.eventColor = item.eventColorSource;
                        item.eventColorSource = null;
                    });
                eventStore.endBatch();
                setMephistoLoading(false)

            }

            setMephistoCompare(!mephistoCompare)

        }

        function handleSelectGame(game) {
            navigate(`/${game.toLowerCase()}`)
        }

        const hideEditor = useCallback(() => {
            if (isExists(eventRecord)) {
                if (eventRecord.isCreating) {
                    eventStore.remove(eventRecord)
                }
            }

            showPopup(undefined)
            setEventRecord(null)
        }, [eventRecord, eventStore])

        const handleClickSave = (data) => {
            if (isExists(eventRecord)) {
                let changes = eventRecord.set({
                    ...data,
                    isCreating: false
                })


                if (isExists(changes)) {
                    if(eventRecord.eventColorSource != undefined && eventRecord.eventColorSource != null &&  eventRecord.eventColorSource != eventRecord.eventColor)
                        eventRecord.eventColor = eventRecord.eventColorSource

                    if (eventRecord.hasGeneratedId) {
                        eventRecord.beginBatch()

                        setStylesForNewEvents(eventRecord, resourceRecord, colorConfig)

                        eventRecord.endBatch()

                        sendAddEvent(eventRecord, game.toLowerCase())
                    } else {
                        sendUpdateEvent(eventRecord, game.toLowerCase())
                    }
                }
            }

            hideEditor()
        }

        const handleClickSaveChildRelease = (data) => {
            if (data.hasGeneratedId) {
                data.beginBatch()
                setStylesForNewEvents(data, resourceRecord)

                data.endBatch()

                sendAddEvent(data, game.toLowerCase())
            } else {
                sendUpdateEvent(data, game.toLowerCase())
            }
        }
        const setStatusForPushToAsanaEventContextMenu = (eventRecord, items) => {
            if (eventRecord.mongoStatus === MONGO_STATUS.NOT_MODIFIED) {
                items.pushToAsana.hidden = true
            } else if (eventRecord.isSyncFromAsana) {
                items.pushToAsana.disabled = true
            }
        }

        async function handleSelectedItems() {
            await pushBulkEventsToAsana(selectedItems, game)
        }

        function groupPushDisabled(){
            if (selectedItems.length === 0) return true;

            let set = new Set(selectedItems.map(e => e.data.type))
            return set.size > 1;

        }

        const getBryntumConfigs = (getEditorConfigs, overrideConfigs = {}) => {
            const configs = {
                ...getCommonConfigs(schedulerRef, user, game, searchParams),
                ...getConfigByGame(user, game)?.role === USER_ROLE.EDITOR? getEditorConfigs() : getViewerConfigs(schedulerRef),
                ...overrideConfigs
            }
            return configs;
        }
        return <Box className="container">

            <Navbar handleSelectGame={handleSelectGame} game={game}
                    handleSelectedItems = {handleSelectedItems}
                    handleMephistoMode={handleMephistoMode}
                    handleCnMode={handleCnMode}
                    mephistoLoading={mephistoLoading}
                    groupPushDisabled = {groupPushDisabled()}
            />
            <Calendar scheduler={schedulerRef}
                      eventStore={eventStore}
                      dependencyStore={dependencyStore}
                      eventRecord={eventRecord}
                      setEventRecord={setEventRecord}
                      resourceRecord={resourceRecord}
                      setResourceRecord={setResourceRecord}
                      hideEditor={hideEditor}
                      popupShown={popupShown}
                      showPopup={showPopup}
                      showNoteEditor={showNoteEditor}
                      handleClickSave={handleClickSave}
                      handleClickSaveChildRelease={handleClickSaveChildRelease}
                      handleSelectGame={handleSelectGame}
                      setStatusForPushToAsanaEventContextMenu={setStatusForPushToAsanaEventContextMenu}
                      getBryntumConfigs={getBryntumConfigs}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
            />
            {user.selectedGame !== SELECTED_GAME.NO_GAME && <HelpButton/>}
        </Box>
    }
}
export default manageCalendar;
